var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-order-item-table',{attrs:{"title":_vm.$t('global.models.order-item.heading'),"subtitle":_vm.$t('global.models.order.subheading'),"formConfigName":'default-with-order'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }